/*
参数:
url: 播放地址
playerId: video标签的id

注意：
1. Chrome 66之后的版本已经禁用了非静音自动播放功能
2. 播放m3u8必须引入 videojs-contrib-hls 或 @videojs/http-streaming 插件
*/

window.startPlay = function (url, playerId) {
    // 先校验播放器容器是否存在
    const videoElement = document.getElementById(playerId);
    if (!videoElement) {
        console.error(`播放器容器不存在，ID：${playerId}`);
        return;
    }

    var options = {
        width: "100%",
        height: "100%",
        // fluid: true, // 改为true，适配容器尺寸，避免布局问题
        language: "zh-CN",
        controls: true,
        autoplay: true,
        loop: false,
        muted: false, // 关键：开启静音，满足Chrome自动播放策略
        preload: "auto", // 预加载，提升播放体验
        sources: [],
        // 新增HLS配置，解决跨域和请求问题
        html5: {
            hls: {
                overrideNative: true, // 强制使用js解析HLS，而非Chrome原生
                maxRetries: 5,
                retryDelay: 1000,
            },
        },
    };

    console.log("检测m3u8格式：", _.endsWith(getBaseUrl(url), ".m3u8"));

    if (_.endsWith(getBaseUrl(url), ".m3u8")) {
        console.log("识别到m3u8格式，配置播放参数");
        options.sources = [
            {
                type: "application/x-mpegURL", // 标准m3u8 MIME类型
                src: url,
            },
        ];
    } else if (_.endsWith(getBaseUrl(url), ".flv")) {
        options["techOrder"] = ["html5", "flvjs"];
        options["flvjs"] = {
            mediaDataSource: {
                isLive: false, // 你的地址是视频不是直播，改为false
                cors: true,
                withCredentials: false,
            },
        };
        options["flash"] = {
            params: {
                wmode: "Opaque",
            },
            swf: "/videojs/video-js.swf",
        };
        options.sources = [
            {
                type: "video/x-flv",
                src: url,
            },
        ];
    } else if (_.startsWith(url, "rtmp://")) {
        options["techOrder"] = ["html5", "flash"];
        options["flash"] = {
            params: {
                wmode: "Opaque",
            },
            swf: "/videojs/video-js.swf",
        };
        options.sources = [
            {
                type: "rtmp/mp4",
                src: url,
            },
        ];
    } else if (_.endsWith(getBaseUrl(url), ".mp3")) {
        options.sources = [
            {
                type: "audio/mp3",
                src: url,
            },
        ];
    } else if (_.endsWith(getBaseUrl(url), ".wav")) {
        options.sources = [
            {
                type: "audio/wav",
                src: url,
            },
        ];
    } else {
        options.sources = [
            {
                type: "video/mp4",
                src: url,
            },
        ];
    }

    // 处理m3u8请求的时间戳参数（保留你的原有逻辑）
    if (videojs.Hls) {
        videojs.Hls.xhr.beforeRequest = function (options) {
            if (_.endsWith(getBaseUrl(options.uri), ".m3u8")) {
                options.uri = updateQueryStringParameter(
                    options.uri,
                    "_t",
                    new Date().valueOf()
                );
            }
            return options;
        };
    } else {
        console.error("未检测到HLS插件，无法播放m3u8格式！");
        return;
    }

    // 先销毁已存在的播放器实例，避免重复初始化报错
    if (window[`videoPlayer_${playerId}`]) {
        window[`videoPlayer_${playerId}`].dispose();
    }

    // 初始化播放器
    var player = videojs(playerId, options);
    window[`videoPlayer_${playerId}`] = player; // 保存实例，方便后续操作

    // 监听播放器事件，定位报错原因
    player.ready(function () {
        console.log("播放器初始化完成，尝试播放视频");
        // 主动触发播放（兼容部分浏览器）
        this.play().catch((err) => {
            console.error("播放失败：", err);
            // 自动播放失败时，提示用户手动播放
            this.pause();
            this.muted(false); // 恢复静音状态，让用户手动点击播放
        });
    });

    // 错误监听：关键！定位具体报错原因
    player.on("error", function (e) {
        console.error("播放器错误信息：", this.error());
        alert("视频播放失败，请检查播放地址或网络！");
    });

    // 加载完成监听
    player.on("loadedmetadata", function () {
        console.log("视频元数据加载完成，时长：", this.duration());
    });
};

// 补充：更新URL参数的工具函数（保留你的原有逻辑）
function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
}

// 补充：获取不带参数的基础URL（保留你的原有逻辑）
window.getBaseUrl = function (url) {
    var pos = url.indexOf("?");
    if (pos === -1) {
        return url;
    } else {
        return url.substr(0, pos);
    }
};
